module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.stepName === _vm.steppersState.currentStepName) ? _c('section', {
    staticClass: "step-content-item",
    class: _vm.steppersState.direction
  }, [_vm._t("default")], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b13caf3","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/uikit/components/AppSteppers/components/AppSteppersPane.vue
// module id = 81efb4265fd98e6a7136
// module chunks = 89